/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Config,
  IFinalResponse,
  InitApiType,
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '../Core';
import { HeadlessDeliveryApiParamsTypes } from '../Types/HeadlessDelivery.types';

export const API_DOMAIN: EndPointsNames = 'ApiLiferay';
export const ENDPOINT_API_PATH =
  '/o/headless-delivery/v1.0/sites/20124/structured-contents';
export const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
export const URL_POSTMAN = '#';
export const CODE_ERRORS: ErrorResponseCodeType<null>[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
];

const definitions = {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};

export const callGet = async (
  params: HeadlessDeliveryApiParamsTypes,
): Promise<IFinalResponse> => {
  const init: InitApiType = {
    params: {},
    headers: {
      'Accept-Language': 'pt-BR',
    },
  };

  init.params.flatten = params.flatter;
  init.params.filter = params.filter
    ?.map((item) => `(${item.param} ${item.conditional} '${item.value}')`)
    .join(' or ');

  if (params?.fields) {
    init.params.fields = params?.fields?.join(',');
  }

  return Config.API.get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};
const call = { get: callGet };

export default { call, definitions };
